import { nullable } from '@ipfabric/utils/fp/nullable';
import { maybePropOf, prop } from '@ipfabric/utils/fp/prop';
import type { SecuritySchemaMergedState } from 'components/SecuritySchema/model/SecuritySchemaModel';
import { selectRuleChainScope } from 'components/SecuritySchema/model/selectors/selectRuleChainScope';
import { option } from 'fp-ts';
import { flow, pipe } from 'fp-ts/lib/function';

export const selectHighlightedRuleIndex = (
  state: SecuritySchemaMergedState,
): number | null =>
  pipe(
    state,
    selectRuleChainScope,
    nullable.chain(prop('name')),
    nullable.chain(
      flow(maybePropOf(state.highlightedRules), option.toNullable),
    ),
  );
